import { useI18n } from '@affine/i18n';
import type { FC } from 'react';

import { BooleanToggle } from '../controls/boolean-toggle';
import type { SectionProps } from './types';

export const SearchSection: FC<SectionProps> = ({ row, setField }) => {
  const t = useI18n();
  return (
    <BooleanToggle
      label={t['com.streamlain.customApps.viewConfig.search.label']()}
      description={t['com.streamlain.customApps.viewConfig.search.desc']()}
      data-sl-field="search"
      value={row.search}
      onChange={v => setField('search', v)}
    />
  );
};
